// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAsLe_NAQ49H3z7RqWvOZsXhgqOZJXxQl4",
  authDomain: "el-samy.firebaseapp.com",
  databaseURL: "https://el-samy-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "el-samy",
  storageBucket: "el-samy.appspot.com",
  messagingSenderId: "37176881927",
  appId: "1:37176881927:web:37012e002967bb3fa44ba2",
  measurementId: "G-9N2QSH9EHH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

export { app, analytics, auth, db, storage, functions };
